function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear() + " ";
    document.getElementById("year").innerHTML = year;
  }
}

$(document).ready(function () {
  current__year();
});